import { useQuery } from "@tanstack/react-query"
import api from "../../../services/apiClient"

interface Agency {
  id: number
  name: string
}

export function useAgencies() {
  return useQuery<Agency[]>({
    queryKey: ["agencies"],
    queryFn: async () => {
      const { data } = await api.get("agency")
      return data?.data?.items ?? []
    },
    staleTime: 1000 * 60 * 30,
  })
}
